import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/contents/tms-2/tms-clinical-study-results",
)({
  beforeLoad: () => {
    throw redirect({ to: "/contents/tms/tms-clinical-study-results" });
  },
});
